/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';

import FormBuilder from '../../../../../helper/formBuilder';

import Schema from '../../../../../schema/form/profile/account';

import Button from '../../../../button';

function Account({ data: account, loading, onUpdateClick }) {
  const isMobile = useMediaQuery({ query: '(max-width: 425px)' });

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: Schema.DefaultValues,
    resolver: yupResolver(Schema.YupSchema),
  });

  useEffect(() => {
    if (account) {
      const { bloodGroup, shirtSize } = account;

      setValue('firstName', account.firstName);
      setValue('lastName', account.lastName);
      setValue('email', account.email);
      setValue('phone', account.phone);
      setValue('dob', account.dob);
      setValue('gender', account.gender);
      setValue('address', account.address || '');
      setValue(
        'bloodGroup',
        bloodGroup
          ? {
              id: bloodGroup.toLowerCase(),
              name: bloodGroup,
            }
          : null,
      );
      setValue(
        'shirtSize',
        shirtSize
          ? {
              id: shirtSize.toLowerCase(),
              name: shirtSize,
            }
          : null,
      );
      setValue('runningGroup', account.runningGroup || '');
      setValue('corporateGroup', account.corporateGroup || '');
    }
  }, [account]);

  const onSubmit = useCallback(data => {
    const user = {
      ...data,
      bloodGroup: data.bloodGroup?.name || null,
      shirtSize: data.shirtSize?.name || null,
      runningGroup: data.runningGroup || null,
      corporateGroup: data.corporateGroup || null,
    };

    delete user.email;
    delete user.phone;

    onUpdateClick(user);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grid grid-cols-12 gap-5 row-gap-5 mb-4">
        {FormBuilder({
          template: Schema.Template,
          control,
        }).map(({ field }, index) => (
          <div key={index} className="col-span-12 sm:col-span-6">
            {field}
          </div>
        ))}
      </div>
      <div className="flex justify-end">
        <Button label="Update" fullWidth={isMobile} loading={loading} disabled={loading} />
      </div>
    </form>
  );
}

Account.defaultProps = {
  data: null,
  loading: false,
};

Account.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  onUpdateClick: PropTypes.func.isRequired,
};

export default Account;
